
import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import { comitesYjurados, crearComite } from "../Redux/comitesJurados";
import TokenContext from "../context/TokenContext";
import TablaComites from "./tablas/TablaComites";
import { COLUMNSCOMITES } from "../columnas/columnasComites";
import ModalComites from "./modales/ModalComites";

const ComitesJurados = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const [comiteJurado, setComiteJurado] = React.useState([])
    const comitesSelector = useSelector(store => store.comites.comitesJurados)

    const [openModal, setOpenModal] = React.useState(false)
    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(comitesYjurados(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (comitesSelector?.length > 0) {
            var array = []
            comitesSelector.forEach(element => {
                var objeto = {
                    id: element.new_participacionencomitesyjuradosid,
                    new_fecha: element["new_fecha@OData.Community.Display.V1.FormattedValue"],
                    new_lugar: element.new_lugar,
                    new_tipodeevaluacin: element["new_tipodeevaluacin@OData.Community.Display.V1.FormattedValue"],
                    _new_institucinconvocante_value: element["_new_institucinconvocante_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setComiteJurado(array)
        }
    }, [comitesSelector])

    const handleSubmit = (datos) => {
        dispatch(crearComite(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose()
                dispatch(comitesYjurados(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Comités y jurados"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TablaComites columnas={COLUMNSCOMITES} lineas={comiteJurado} handleOpen={handleOpen} />
                    </Grid>
                </Grid>
            </Box>
            <ModalComites open={openModal} handleClose={handleClose} onSubmit={handleSubmit} />
        </motion.div>
    )
}

export default ComitesJurados